import { catchError, finalize, of, tap } from 'rxjs';
import { computed, Injectable, OnInit, signal } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { Router } from '@angular/router';

import { ProgressResponse, data, steps } from '../../../modules/check-docs/domain/progress-response';
import { NotificationService } from './notification.service';
import { CnpjService } from './cnpj.service';
import { PharmasyncService } from '../../components/pharma-sync/service/pharmasync.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardService implements OnInit {

  private _response = signal<ProgressResponse>({ data: [], sucess: false });


  docRes: ProgressResponse = {} as ProgressResponse;

  missingDocuments: boolean = false;
  public hasError = signal(false);

  public records = computed(() => this._response().data);

  public firstRecord = computed<data | undefined>(() =>
    this.records().length > 0 ? this.records()[0] : undefined
  );

  // 5) Array de passos do primeiro registro
  public steps = computed<steps[]>(() =>
    this.firstRecord()?.steps ?? []
  );

  // 6) Computed signals para cada passo
  public hasCertificadoA1 = computed(() =>
    this.steps().some(s => s.stepName === 'Certificado A1' && s.finished)
  );
  public hasDescredenciamento = computed(() =>
    this.steps().some(s => s.stepName === 'Descredenciamento' && s.finished)
  );
  public hasSmartped = computed(() =>
    this.steps().some(s => s.stepName === 'Smartped' && s.finished)
  );
  public hasPharmaSync = computed(() =>
    this.steps().some(s => s.stepName === 'PharmaSync' && s.finished)
  );

  // 7) Indica se existe algum passo **não** concluído
  public hasMissingDocuments = computed(() =>
    this.steps().some(s => !s.finished)
  );

  constructor(
    private router: Router,
    private apiService: ApiService,
    private notificationService: NotificationService,
    private cnpjService: CnpjService,
    private pharmaSyncService: PharmasyncService
  ) {
    this.loadOnboard();
  }

  ngOnInit(): void {
    this.checkDocuments();
  }

  public loadOnboard(): void {
    this.hasError.set(false);
    this.apiService.allOnboard().pipe(
      tap((res: ProgressResponse) => {
        this._response.set(res);
      }),
      catchError(err => {
        console.error('Erro ao carregar Onboard:', err);
        this.hasError.set(true);
        return of({ data: [], sucess: false } as ProgressResponse);
      })
    ).subscribe();
  }

  public checkDocuments(): void {
    const item = localStorage.getItem('PENDENCIAS-ONBOARD');

    if (item) return
    this.allOnboard();
  }

  public allOnboard(): void {
    this.hasError.set(false);
    this.apiService
      .allOnboard()
      .pipe(
        tap((response) => {
          this.handleDocuments(response)
        }),
        catchError(() => {
          this.hasError.set(true);
          return of([]);
        })
      )
      .subscribe();
  }

  private checkForInovaPharmaSync(response: ProgressResponse): void {
    response.data.forEach(onboard => {
      if (onboard.steps.find(step => step.stepName === 'PharmaSyncTunnelCreated' && step.finished)) {
        this.pharmaSyncService.setPharmaSyncTunnelCreated.set(true);
        // this.hasPharmaSync.set(true);
      }
    })
  }

  private handleDocuments(response: ProgressResponse): void {
    this.docRes = response;
    this.checkForInovaPharmaSync(this.docRes)
    this.docRes.data.forEach(onboard => {
      if (!onboard.completed) {
        const formattedJson = JSON.stringify(this.docRes, null, 2);
        localStorage.setItem('PENDENCIAS-ONBOARD', formattedJson)
        // this.notificationService.sendNotification(
        //   [
        //     {
        //       title: 'Atenção!',
        //       message: `Identificamos que faltam documentos para o cnpj: ${this.formatedCnpj(onboard.cnpj)} do seu onboarding, clique aqui para resolver`,
        //       type: 'warning',
        //       onAction: this.redirectUrl.bind(this,onboard.cnpj),
        //       // duration: 40000000
        //     }
        //   ]
        // );
      }
      else {
        localStorage.removeItem('PENDENCIAS-ONBOARD')
      }
    })
  }

  redirectUrl(cnpj: string): void {
    this.cnpjService.setSelectedCnpj(cnpj)
    this.router.navigate(['/onboard'])
  }

  formatedCnpj(value: string): string {
    if (!value) {
      return '';
    }
    // Remove caracteres não numéricos
    const cnpjValue = value.replace(/\D/g, '');

    // Formata o CNPJ: 00.000.000/0000-00
    const formattedCnpj = cnpjValue.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");

    return formattedCnpj;
  }

}